import React from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import moment from 'moment'
import 'moment/locale/da'
import { toast } from 'react-toastify'
import { ColorCategoryActions, ColorCategoryStore, STATUS } from 'Stores/colorCategoryStore'
import { priorities } from '../../stores/colorCategoryStore'

export default class ColorCategoryList extends Component {
  constructor(props) {
    super(props)
    this.stores = [ColorCategoryStore]
    this.storeKeys = ['colorCategories', 'status']
  }

  componentDidMount() {
    ColorCategoryActions.getColorCategories()
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Fetching ColorCategories Failed', {
        autoClose: 7500,
        onClose: () => {
          ColorCategoryActions.clearToast()
        }
      })
      ColorCategoryActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Delete ColorCategory Failed', {
        autoClose: 7500,
        onClose: () => {
          ColorCategoryActions.clearToast()
        }
      })
      ColorCategoryActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('ColorCategory Deleted', {
        autoClose: 7500,
        onClose: () => {
          ColorCategoryActions.clearToast()
        }
      })
      ColorCategoryActions.clearToast()
    }
  }

  render() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <CollapsibleCard startOpen header={<strong>ColorCategories</strong>}>
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'ColorCategoryID'
            },
            fieldFunctions: {
              bodyText: e => {
                if (e.bodyText) {
                  const maxStringLength = 100
                  let shownText = e.bodyText.substring(0, maxStringLength)
                  if (e.bodyText.length > maxStringLength) {
                    shownText += '...'
                  }
                  return shownText
                }
              },
              poolOrder: e => {
                return priorities[e.poolOrder / 10]
              },
              timeStart: e => {
                if (e.timeStart) {
                  return moment(e.timeStart).format('DD-MM-YYYY ')
                }
              },
              timeEnd: e => {
                if (e.timeEnd) {
                  return moment(e.timeEnd).format('DD-MM-YYYY')
                }
              }
            },
            fieldStringFunctions: {
              poolOrder: e => {
                return e.poolOrder
              },
              timeStart: e => {
                return moment(e.timeStart).format('x')
              },
              timeEnd: e => {
                return moment(e.timeEnd).format('x')
              }
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup>
                    <Tooltip target={'edit' + e.ColorCategoryID}>Rediger</Tooltip>
                    <Button tag={Link} to={'/color-categories/' + e.ColorCategoryID} id={'edit' + e.ColorCategoryID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    <Tooltip target={'delete' + e.ColorCategoryID}>Slet</Tooltip>
                    <Button
                      id={'delete' + e.ColorCategoryID}
                      color='danger'
                      onClick={() => {
                        if (confirm('Vil du slette denne produkttype?')) {
                          ColorCategoryActions.deleteColorCategory(e.ColorCategoryID)
                        }
                      }}
                    >
                      <FontAwesomeIcon icon='trash' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            ColorCategoryID: 'ID',
            name: 'Name',
            hexCode: 'Hex Code'
          }}
          data={this.state.colorCategories}
        />
      </CollapsibleCard>
    )
  }
}
